import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { v4 as uuidv4 } from 'uuid';
import {
  GetMembersSuccess,
  GetSchemaSuccess,
  LoadAssignCheckbookCols,
  NavigateToMember,
  SearchChanged,
  SelectedMemberChanged,
  SubmitAssignCheckbookData,
  ValidUntilDateChanged,
  ValidUntilDateCleared,
} from '../actions/assign-checkbook.actions';
import { CloseCheckbooksSidenav } from '../actions/sidenav.actions';
import { Member } from '../models/assign-checkbook.model';
export interface AssignCheckbookState extends EntityState<Member> {
  validUntilDate: Date | null;
  validUntilDateFormat: string;
  search: string;
  displayedColumns: { [label: string]: string };
  showTable: boolean;
  schema: string;
  loyaltyMemberId: number | null;
  selectedMember: any;
  isSubmittedData: boolean;
}

export const assignCheckbookAdapter = createEntityAdapter<Member>();

const initialState: AssignCheckbookState = assignCheckbookAdapter.getInitialState({
  validUntilDate: null,
  validUntilDateFormat: '',
  search: '',
  displayedColumns: {},
  showTable: false,
  schema: '',
  loyaltyMemberId: null,
  selectedMember: [],
  isSubmittedData: false,
});

export const AssignCheckbookReducer = createReducer(
  initialState,
  on(SearchChanged, (state, { search }) => ({
    ...state,
    search,
  })),
  on(ValidUntilDateChanged, (state, { validUntilDate, validUntilDateFormat }) => ({
    ...state,
    validUntilDate,
    validUntilDateFormat,
  })),
  on(ValidUntilDateCleared, (state) => ({
    ...state,
    validUntilDate: null,
    validUntilDateFormat: '',
  })),
  on(GetMembersSuccess, (state, { response }) => {
    const data = response.map((item: any) => ({ ...item, id: uuidv4() }));

    return {
      ...assignCheckbookAdapter.setAll(data, state),
      showTable: data.length > 0 ? true : false,
      loyaltyMemberId: data.length === 1 ? data[0].ticketLoyaltyMemberDto.loyaltyMemberId : null,
    };
  }),
  on(LoadAssignCheckbookCols, (state, { displayedColumns }) => ({
    ...state,
    displayedColumns,
  })),
  on(GetSchemaSuccess, (state, { response }) => ({
    ...state,
    schema: response.length > 0 ? response[0].loyaltySchemaName : '',
  })),
  on(NavigateToMember, (state, { loyaltyMemberId }) => ({
    ...state,
    loyaltyMemberId,
  })),
  on(SelectedMemberChanged, (state, { selectedMember }) => ({
    ...state,
    loyaltyMemberId: selectedMember,
  })),
  on(SelectedMemberChanged, (state, { selectedMember }) => ({
    ...state,
    loyaltyMemberId: selectedMember,
  })),
  on(SubmitAssignCheckbookData, (state) => ({
    ...state,
    isSubmittedData: true,
  })),
  on(CloseCheckbooksSidenav, (state) => ({
    ...state,
    validUntilDate: null,
    validUntilDateFormat: '',
    search: '',
    displayedColumns: {},
    showTable: false,
    schema: '',
    loyaltyMemberId: null,
    selectedMember: [],
    isSubmittedData: false,
  })),
  on(ActiveComponentChanged, () => initialState),
);
